<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->
<div class="wbs-sync-container">
	<mat-table [dataSource]="demoTable">
		<ng-container matColumnDef="wbsCode">
			<mat-header-cell class="shrink-first-column wbs-table-header" *matHeaderCellDef
				>{{ strings.WBS_CODE }}
			</mat-header-cell>
			<mat-cell class="shrink-first-column wbs-table-cell" *matCellDef="let row">{{ row.wbsCode }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="touchplanPhase">
			<mat-header-cell class="wbs-table-header" *matHeaderCellDef>{{
				strings.WBS_DEMO_TABLE_HEADER_PHASE
			}}</mat-header-cell>
			<mat-cell class="wbs-table-cell" *matCellDef="let row">{{ row.touchplanPhase }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="wbsName">
			<mat-header-cell class="wbs-table-header" *matHeaderCellDef>{{
				strings.WBS_DEMO_TABLE_HEADER_NAME
			}}</mat-header-cell>
			<mat-cell class="wbs-table-cell" *matCellDef="let row">{{ row.wbsName }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="startDate">
			<mat-header-cell class="wbs-table-header" *matHeaderCellDef>{{
				strings.WBS_DEMO_TABLE_HEADER_START
			}}</mat-header-cell>
			<mat-cell class="wbs-table-cell" *matCellDef="let row">{{ row.startDate }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="finishDate">
			<mat-header-cell class="wbs-table-header" *matHeaderCellDef>{{
				strings.WBS_DEMO_TABLE_HEADER_FINISH
			}}</mat-header-cell>
			<mat-cell class="wbs-table-cell" *matCellDef="let row">{{ row.finishDate }}</mat-cell>
		</ng-container>
		<mat-header-row *matHeaderRowDef="demoTableColumns"></mat-header-row>
		<mat-row class="wbs-table-cell" *matRowDef="let myRowData; columns: demoTableColumns"></mat-row>
	</mat-table>

	<ol class="vertical-spacing-xl">
		<li class="vertical-spacing-xl">{{ strings.WBS_INSTRUCTIONS_STEP_1 }}</li>
		<li class="vertical-spacing-xl">{{ strings.WBS_INSTRUCTIONS_STEP_2 }}</li>
		<li class="vertical-spacing-xl">
			{{ strings.WBS_INSTRUCTIONS_STEP_3 }}&nbsp;<strong>{{ strings.WBS_INSTRUCTIONS_SYNC }}</strong
			>.
		</li>
	</ol>

	<div class="file-uploader-container">
		<a [href]="strings.WBS_INSTRUCTIONS_LINK" target="_blank" class="vertical-spacing-xxl">Learn More</a>
		<div class="uploader-container">
			<mat-file-upload
				class="file-uploader"
				[formControl]="form"
				[acceptedFileTypes]="['.csv', '.txt']"
				[placeholder]="strings.WBS_CSV_FILE_UPLOAD_PLACEHOLDER"
				[validationErrors]="ValidationData"
				[successMessage]="strings.WBS_CSV_FILE_UPLOAD_SUCCESS"
				[outputFormat]="UploadOutputFormat.Text"
			>
			</mat-file-upload>
			<div class="sync-button">
				<button
					mat-stroked-button
					color="primary"
					(click)="save()"
					[disabled]="!(form.valueChanges | async) || !form.valid"
				>
					{{ strings.WBS_INSTRUCTIONS_SYNC | uppercase }}
				</button>
			</div>
		</div>
	</div>

	<button-footer
		(buttonSaveOrClose)="onClose()"
		[saveOrCloseButtonText]="strings.UICONTROL_TEXT_CLOSE | uppercase"
	>
	</button-footer>
</div>
